let counter = 0
const globalAny = global

/** This is used to make the execution delayed
 *  @param {number} ms - time in milliseconds to get delayed
 *  @returns { Promise<number> }
 */
export const getSleep = (ms) =>
  new Promise(resolve => {
    setTimeout(resolve, ms)
  })

/**
 * Returns black box values by checking whether its present in the global object window.IGLOO, if not present it checks maximum 10 times for it to return blackbox value data.
 * @returns { blackbox: string,  finished: boolean}
 */
const getBlackBoxValues = async () => {
  const blackboxValues = globalAny.window.IGLOO.getBlackbox
  ? globalAny.window.IGLOO.getBlackbox()
  : {}

  if (!blackboxValues.finished && counter < 10) {
    counter += 1
    await getSleep(500)
    return getBlackBoxValues()
  }
  return blackboxValues.blackbox
}

export default getBlackBoxValues
